import type { HelpFile } from '../../types/help'
import { DefinitionImpactConfirmDialogTestIds } from '../../../testids/DefinitionImpactConfirmDialogTestIds'

export const definitionImpactConfirmDialogHelp: HelpFile = {
  docPage: '/docs/admin/attribute-definitions',
  texts: {
    [DefinitionImpactConfirmDialogTestIds.definitionImpactConfirmDialog]:
      'Changing this attribute definition affects existing data — review the impact summary, then choose whether to migrate values.',
    [DefinitionImpactConfirmDialogTestIds.impactConfirmationCheckbox]:
      'Confirm that you have reviewed the impact before saving.',
    [DefinitionImpactConfirmDialogTestIds.impactConfirmButton]: 'Save the changes without migrating existing values.',
    [DefinitionImpactConfirmDialogTestIds.saveWithMigrationButton]: 'Save and migrate existing attribute values to the new definition where safe.',
    [DefinitionImpactConfirmDialogTestIds.impactConfirmCancel]: null,
  },
}
